<app-side-top-bar [navigationItems]="navigationItems">
  <main class="invoices-received">
    <section class="received-section">
      <header class="header">
        <h2>{{ labelService.getLabel("invoices_received") }}</h2>
      </header>

      <app-table-received-invoices
        [invoices]="invoices"
        [isLoadingInvoices]="isLoadingInvoices"
      ></app-table-received-invoices>
    </section>
  </main>
</app-side-top-bar>
